export default "__VITE_ASSET__DH$ZcwpB__"